import { ROOM_TYPE_COMBINED } from "@Pages/Search/components/FilterSection/data/filtersList";
import config from "@Config/index";
import { renderChinaNamedMonth } from "@Utils/cnDisplayDate";

const getCurrentFilterName = (
  filterName: string,
  currFilters: any,
  t: (key: string) => string = (key) => key,
) => {
  if (filterName === "sortKey") {
    return "";
  }

  if (filterName === "dualOccupancy" && currFilters["dualOccupancy"]) {
    return "Dual Occupancy";
  }

  if (filterName === "moveInMonth") {
    const raw = currFilters?.[filterName];
    if (!raw) return "";
    const legacy = String(raw).replace("-", ", ");
    if (config.IS_CHINA_APP) {
      return renderChinaNamedMonth(raw, legacy) || legacy;
    }
    return legacy;
  }

  if (filterName === "roomType") {
    const combinedRoomTypes: any =
      ROOM_TYPE_COMBINED.reduce(
        // @ts-ignore
        (acc, curr) => [...acc, ...(curr.list || [])],
        [],
      ) || [];

    return (currFilters?.[filterName] || [])?.reduce((acc: string, curr: string) => {
      const name = combinedRoomTypes.find((f: any) => f.value === curr)?.name || "";
      const translatedName = name ? t(name) : "";
      return `${acc} ${acc === "" ? "" : "+"} ${translatedName}`;
    }, "");
  }

  if (currFilters?.[filterName] === "all_selected") {
    return "";
  }
  return currFilters?.[filterName] == "46 weeks" ? "45+ weeks" : currFilters?.[filterName] || "";
};

export default getCurrentFilterName;
